// utils
// import { suggestedNetwork } from '../../components/carousel/network/NetworkCarousel.mocks';
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ManagerCard from '../../../components/carousel/manager/ManagerCard';
import ManagerGrid from '../../../components/cards/manager-grid/ManagerGrid';
import { useAuth, useEquipeRegiao, useRegiao, useSiteRegiao } from '../../../components/context/Info';
import WhatsAppComponent from '../../../components/fixed/whatsapp/WhatsappComponent';
import WelcomePiecesCompany from '../../../components/pieces/welcomeCompany/WelcomePiecesCompany';
import PopUpComponent from '../../../components/popUp/PopUpComponent';
import { filtraCidadesRegiao } from '../../../lib/region';
import { getMenuServerSideProps } from '../../../lib/server/site-props';
import { menu } from '../../../services/menus';
import { managers } from '../../../services/site';
import { formatSelects } from '../../../utils/FunctionsGlobals';
import SiteHead from '../../../utils/siteHead';
import { descricaoPaginaMenu, tituloPaginaMenu } from '../../../utils/seoPaginaMenu';
import { mesmoTituloMenu } from '../../../utils/tituloMenu';
import WelcomePiecesMenu from './components/pieces/welcome/WelcomePiecesMenu';
import styles from './menu.module.css';

const AboutPieces = dynamic(() => import('../../../components/pieces/about/AboutPieces'), { ssr: false });
const AboutPieces1 = dynamic(() => import('../../../components/pieces/about1/AboutPieces1'), { ssr: false });
import { NEW_RODAPE } from '../../../components/registry/home';
const AboutPieces2 = dynamic(() => import('../../../components/pieces/about1/AboutPieces2'), { ssr: false });
const MegaFooter = dynamic(() => import('../../../components/pieces/mega-footer/MegaFooter'), { ssr: false });
const EditorialFooter = dynamic(() => import('../../../components/pieces/editorial-footer/EditorialFooter'), { ssr: false });

export const getServerSideProps = getMenuServerSideProps;

const Menu = () => {
    // useState
    
    const {
        allDataHome,
        init_props,
        isMobile1,
        favorito
    } = useAuth();
    // useState
    const allCity = allDataHome?.cidades;
    // MULTI-FILIAIS: contato/cidades da filial ativa (sem região = igual a hoje).
    const { regiaoAtiva } = useRegiao();
    const allCities = filtraCidadesRegiao<any>(allCity ? formatSelects(allCity) : [], regiaoAtiva);
    const site = useSiteRegiao(allDataHome?.site);
    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const bannerListagem = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "listagem");
    const urlBannerListagem = bannerListagem ? bannerListagem.length > 0 ? bannerListagem[0] : null : null;
    const origin = init_props?.origemInit;
    const codsite1 = init_props?.codsite;
    const [allMenu, setAllMenu] = useState<any>(init_props?.menu || null);
    const router = useRouter();
    const codsite2 = init_props?.codsite;
    const menuName = Array.isArray(router.query.name)
        ? router.query.name[0]
        : router.query.name;
    // method

    const routes = ['home', allMenu?.titulo];
    // O cache de `allManagers` no localStorage continua GLOBAL (a lista do
    // tenant); o recorte por filial acontece só no RENDER — assim trocar de
    // filial não exige invalidar/reconstruir o cache.
    const [allManagers, setAllManagers] = useState<any>([]);
    const allManagersRegiao = useEquipeRegiao<any>(allManagers);

     const renderRodape = () => {
        // REGISTRY: variante nova de rodapé ANTES do switch legado — o lookup devolve
        // undefined para os modelos 1-5, então o diff nos ~300 sites é nulo.
        const RodapeNovo = NEW_RODAPE[Number(site?.rodape)];
        if (RodapeNovo) {
            return (
                <RodapeNovo
                    site={site}
                    allCities={allCities}
                    allCitiesTipes={allDataHome?.tipos}
                    codsite={codsite2}
                    origin={origin}
                    isMobile={isMobile1}
                    allRodape={allDataHome?.rodape}
                    favorito={favorito}
                />
            );
        }

        switch (site?.rodape) {
            case 1:
                return (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                    </motion.div>
                );
            case 2:
                return (
                    <AboutPieces allRodape={allDataHome?.rodape} site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1}/>
                );
            case 3:
                return (
                    <AboutPieces2 site={site} allRodape={allDataHome?.rodape}/>
                );
            case 4:
                return (
                    <MegaFooter
                        site={site}
                        allCities={allCities}
                        codsite={codsite2}
                        origin={origin}
                        isMobile={isMobile1}
                        favorito={favorito}
                        allRodape={allDataHome?.rodape}
                        fallback={<AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>}
                    />
                );
            case 5:
                return (
                    <EditorialFooter
                        site={site}
                        allCities={allCities}
                        codsite={codsite2}
                        origin={origin}
                        isMobile={isMobile1}
                        favorito={favorito}
                        allRodape={allDataHome?.rodape}
                        fallback={<AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>}
                    />
                );
            default:
            return (
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                </motion.div>
            );
        }
    }

    useEffect(() => {
        if (!router.isReady || !menuName) return;
        // SD-0037: mesma regra do SSR (sem acento/caixa/espaço nas pontas; NFC = NFD). Comparar EXATO
        // aqui mandava para a home, ~1,5 s depois de abrir, a página que o servidor já tinha montado.
        if (mesmoTituloMenu(allMenu?.titulo, menuName)) return;

        if (mesmoTituloMenu(init_props?.menu?.titulo, menuName)) {
            setAllMenu(init_props.menu);
            return;
        }

        const GetMenus = async () => {
            const arrayMenus = await menu(origin, codsite1);
            const getMenu = (arrayMenus?.menus?.filter(
                (v: any) => mesmoTituloMenu(v.titulo, menuName)
            ))
            if(getMenu?.length > 0) {
                // 21/08: título repetido = página apagada e recriada. A DISPONÍVEL
                // vence (senão o site servia a versão velha e a edição do cliente
                // parecia não pegar). Sem nenhuma disponível, mantém a primeira.
                setAllMenu(getMenu.find((v: any) => Number(v?.Disponivel) === 1) || getMenu[0])
            }else{
                setAllMenu(null)
                router.replace('/');
            }
        }
        GetMenus();
    }, [allMenu?.titulo, codsite1, init_props?.menu, menuName, origin, router]);

    useEffect(() => {
        const GetManager = async () => {
            const cacheManager = localStorage.getItem('allManagers') || '';
            if(cacheManager) {
                setAllManagers(JSON.parse(cacheManager))
            } else {
                const getManagers = await managers();
                if(getManagers?.parceiros?.length > 0) {
                    setAllManagers(getManagers?.parceiros?.filter(
                        (v: any) => v.url_foto?.length
                    ) || [])
                    localStorage.setItem( 'allManagers', JSON.stringify(getManagers?.parceiros?.filter(
                        (v: any) => v.url_foto?.length
                    ) || []));
                }
            }
        }

        if(allMenu?.titulo == "Equipe") {
            GetManager();
        }
    }, [allMenu])

    // SEO próprio da página (INC-0283, todos os sites): "<título> | <nome do site>" e o início do texto da
    // página — antes o SiteHead sobrescrevia com o title/description da home. Sem texto → description da home.
    const tituloSeo = tituloPaginaMenu(allMenu?.titulo, site) || allMenu?.titulo;
    const descricaoSeo = descricaoPaginaMenu(allMenu?.Conteudo) || undefined;

    return (
        <div className={styles.container} style={{background: site?.cor5}}>
            <Head>
                <title>{tituloSeo}</title>
            </Head>
            {allDataHome ? <SiteHead allDataHome={allDataHome} pagina={"home"} canonicalHost={init_props?.prodOrigin} titleOverride={tituloSeo || undefined} descriptionOverride={descricaoSeo} /> : null}
            <WhatsAppComponent site={site} />
            <PopUpComponent />
            {allMenu?.Topo ?
                <>
                    <WelcomePiecesCompany
                        site={site}
                        activeDrawer={activeDrawer}
                        setActiveDrawer={setActiveDrawer}
                        titulo={allMenu?.titulo}
                        routes={routes}
                        favorito={[]}
                        bannerListagem={urlBannerListagem}
                        props={allDataHome}
                    />
                </>
                : null
            }
            {allMenu?.titulo == "Equipe" ?
                Number(site?.carrossel_corretores) && allManagersRegiao.length ? (
                    <div id="equipe">
                    {site?.modelo_equipe == 3 ? (
                    <ManagerGrid
                        slides={allManagersRegiao}
                        title={site?.id == 1959 ? "Parceiros" : site?.id == 2122 ? "COMPRA, VENDA E LOCAÇÃO DE IMÓVEIS" : site?.id == 2551 ? "EQUIPE DE VENDAS" : "NOSSA EQUIPE"}
                        site={site}
                    />
                    ) : (
                    <ManagerCard
                        slides={allManagersRegiao}
                        title={site?.id == 1959 ? "Parceiros" : site?.id == 2122 ? "COMPRA, VENDA E LOCAÇÃO DE IMÓVEIS" : site?.id == 2551 ? "EQUIPE DE VENDAS" : "NOSSA EQUIPE"}
                        site={site}
                    />
                    )}
                    </div>
                ) : null
            :
                <WelcomePiecesMenu site={site} menu={allMenu}/>
            }
            {/* rodapé global do site, mas a página pode ocultá-lo (flag Rodape=0 vinda do builder de Páginas do Site) */}
            { Number(allMenu?.Rodape ?? 1) !== 0 ? renderRodape() : null }
        </div>
    );
};

export default Menu;
